import { API } from "aws-amplify";

export async function mailchimpSubscribeAPI(email) {
  await API.get("ilingu", "/mailchimp/subscribe", {
    queryStringParameters: {
      subscriber: email
    }
  })
}